import { ProcessOutCardFieldIds } from '../types/ProcessOutCardFieldIds'
import { ProcessOutExceptionCodes } from '../types/ProcessOutExceptionCodes'

export const PROCESSOUT_VALIDATION_ERROR_TARGETS: Partial<
  Record<ProcessOutExceptionCodes, ProcessOutCardFieldIds>
> = {
  [ProcessOutExceptionCodes.CARD_INVALID_NAME]: ProcessOutCardFieldIds.NAME,
  [ProcessOutExceptionCodes.CARD_MISSING_NUMBER]: ProcessOutCardFieldIds.NUMBER,
  [ProcessOutExceptionCodes.CARD_INVALID_NUMBER]: ProcessOutCardFieldIds.NUMBER,
  [ProcessOutExceptionCodes.CARD_MISSING_EXPIRY]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_EXPIRY_DATE]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_DATE]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_EXPIRY_MONTH]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_MONTH]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_EXPIRY_YEAR]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_YEAR]:
    ProcessOutCardFieldIds.EXPIRY_DATE,
  [ProcessOutExceptionCodes.CARD_INVALID_CVC]:
    ProcessOutCardFieldIds.SECURITY_CODE,
  [ProcessOutExceptionCodes.CARD_MISSING_CVC]:
    ProcessOutCardFieldIds.SECURITY_CODE,
  [ProcessOutExceptionCodes.CARD_FAILED_CVC]:
    ProcessOutCardFieldIds.SECURITY_CODE,
}
